// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"156":"b306fae8","775":"b306fae8","805":"913ed284"}[chunkId] + ".chunk.css";
};